<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>內容檢索</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="sub-line"></div>



    <div class="content">
      <div class="search-box">

      <div class="info-row">
       <div >
          <div class="search-bar-div" >
              <span class="sp-add" @click="sp_add">+</span>
              <span @click="sp_reduce" class="sp-reduce" style="visibility:hidden">-</span>
              <select v-model="searchitem0['stype']" class="drop" >
                <option value="全局">全局</option>
                <option value="主題名">主題名</option>
                <option value="類型">類型</option>
                <option value="港口">港口</option>
                <option value="內容">內容</option>
              </select>
              <input v-model="searchitem0['stxt']" class="tbox" />
              <select v-model="searchitem0['slogic']" style="visibility:hidden" class="drop-and"><option>與</option>
              </select>
          </div>
        </div>
        <div v-for="item in searchitems" :key="item[0]"  >
          <div  class="search-bar-div">
            <span @click="sp_add" class= "sp-add" >+</span>
            <span @click="sp_reduce" class="sp-reduce">-</span>
            <select v-model="item['stype']" class="drop" >
              <option value="全局">全局</option>
              <option value="主題名">主題名</option>
              <option value="類型">類型</option>
              <option value="港口">港口</option>
              <option value="內容">內容</option>
            </select>
            <input class="tbox"  v-model="item['stxt']"/>
            <select v-model="item['slogic']" class="drop-and">
              <option value="與">與</option>
              <option value="或">或</option>
              <option value="非">非</option>
            </select>
          </div>
        </div>
      </div>
     

        <div class="info-row">
          <div class="two-btns">
            <button @click="eliminate"  class="btn1">清除</button>
            <button @click="getList" class="btn2">搜索</button>
          </div>
          
        </div>
        
      </div>

      <div class="data-box">
        <div class="data-menu">
          <div class="data-menu-left">
            <div>數據表單</div>
            <div class="l-img"><img src="../assets/icon/line.png"></div>
          </div>
          <div @click="exportExcel" class="data-menu-right">
            <div class="r-img"><img src="../assets/icon/download1.png"></div>
            <div class="download-excel">
              <a >excel下載</a>
            </div>
          </div>
        </div>

        <div class="tab-data">

           <template>
            <el-table
            v-loading="pictLoading"
            element-loading-text="數據正在加載中"
            element-loading-spinner="el-icon-loading"
             class="el-table"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              @row-click="todetail"
              :cell-style="cellStyle"

              style="margin-left:50px; width: 1100px;">
              <el-table-column
                prop="gxsd_pubulish_serial"
                label="類別"
                width="350">
              </el-table-column>
              <el-table-column
                prop="gxsd_chinese_title"
                label="主題名"
                width="350">
              </el-table-column>
              <el-table-column
                prop="gxsd_date_time"
                label="時間"
                width="150">
              </el-table-column>
              <el-table-column
                prop="gxsd_port_name"
                label="地址"
                width="250">
              </el-table-column>
            </el-table>

            <div style="width:1150px">
              <div style="text-align: right;margin-top: 15px;">
              <el-pagination
                background
                :current-page="currrentpage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                :data="tableData"
                :row-style="tableRowStyle"
                :header-cell-style="tableHeaderColor"
                layout="total,sizes,prev, pager, next"
                :total="totalcount"
                @current-change="current_change"
                @size-change="size_change">
              </el-pagination>
            </div>

            </div>

            


          </template>

        </div>

      </div>
      


        
    </div>
  </div>
</template>



<script>
import FileSaver from '../lib/FileSaver.min.js';
import XLSX from 'xlsx'
export default {
  name: "app",
  data() {
    return {
      seniorIndex:0,
      seniorArray:[],
      currrentpage:1,
      pageSize:20,
      totalcount:100,
      object:{},
      searchitem0:{"stype":"全局","stxt":"","slogic":"與"},//第一个搜索框
      searchitems:[],//其他搜索框
      pictLoading:false,
    };
  },
  methods: {

    //
    cellStyle(data){
      if(data.columnIndex>-1){
        return "cursor:pointer;"
      }

    },


    todetail(row){
      //row.ID;
      //console.log("行号id："+row.ID);
      this.$router.push({ path: "/hghome_datadetail",query:{bid:row.ID}});
    },


    //导出excel
    exportExcel(){
      var wb = XLSX.utils.table_to_book(document.querySelector('.el-table'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout;
    },
   
        tableRowStyle({row,rowIndex}){
          let st;
          if(rowIndex%2==1){
            st={
              'background-color':'#f0f0f0',
            };

          }
          return st;
          },
            //设置表头行的样式
        tableHeaderColor({row,column,rowIndex,columnIndex}){
              return 'background-color:#d4c9bc;color:#9a7455;font-wight:500;font-size:16px;text-align:center;height: 50px';
            },

        copyarr(arr){
          let a=[];
          for(let i=0,l=arr.length;i<l;i++) {
              a.push(arr[i]);
          }
          return a;

        },

        

        getJson() {
            this.seniorArray=this.copyarr(this.searchitems);
            
            this.seniorArray.push(this.searchitem0);
            
            this.object['pSize'] = this.pageSize;
            this.object['pIndex'] = this.currrentpage;
            this.object['searchlist'] =this.seniorArray;//JSON.stringify(this.seniorArray); //

            let json = JSON.stringify(this.object);
            return json;
            
        },

        
        

        current_change(val){
          this.currrentpage=val;
          this.retrieval();
        },
        size_change(val){
          this.pageSize=val;
          this.retrieval();

          //this.submitform();
        },
        

        getList() {
          //console.log("高级检索开始！");
            let json = this.getJson();
            this.pictLoading=true;
            this.$http
              .post(`${this.$store.state.baseurl}/api/hghomeDetail`,json)
              .then((res) => {
                let json=JSON.parse(res.data);
                this.tableData=json.data;
                this.totalcount=json.dataSize;
                this.pictLoading=false;

              });
        },




        //搜索
        retrieval() {
          var rcode=window.sessionStorage.getItem('hgcode');
          //alert(rcode);
          if(rcode!=null){
              this.getList();
          }
          else{
            this.$message('请登錄！');
          }
            
        },

        
        

        //清除

        eliminate() {
            history.go(0);
        },
        //增加条件

        sp_add() {
            this.seniorIndex++;
            //console.log(this.seniorIndex);
            if (this.seniorIndex < 5) {


                //搜索框
                //this.searchitems.push(0);
                let arr={"stype":"全局","stxt":"","slogic":"與"};
                this.searchitems.push(arr);
            } else {
                this.seniorIndex = 4;
            }
           

        },
        //删除条件


        sp_reduce() {
            this.seniorIndex--;
            if (this.seniorIndex < 0) {
                this.seniorIndex = 1;
            }
            this.searchitems.splice(0, 1);
            //console.log(this.searchitems);
          
        },
  },
  created() {
    
    //获取当前条目ID号
    //this.retrieval();
    this.getList();
  }
};
</script>


<style scoped lang="scss">



select::-ms-expand {
    display: none;
}



.search-bar-div {
    float: left;
    width:990px;
    padding:0 111px;
    margin-top:20px;
}
    .search-bar-div span {
        cursor: pointer;
    }

    .search-bar-div .drop {
        width: 119px;
        height: 52px;
        border: 1px solid #e4e4e4;
        padding-left: 30px;
        margin-left: 15px;
    }
    .search-bar-div .tbox {
        width: 609px;
        height: 50px;
        border: 1px solid #e4e4e4;
        margin-left: 20px;
        padding-left:20px;
    }
    .search-bar-div .drop-and {
        width: 120px;
        height: 52px;
        border: 1px solid #e4e4e4;
        padding-left: 30px;
        margin-left: 20px;
    }
    .search-bar-div .sp-add {
        font-size: 20px;
        font-weight: bold;
        color: #ad6d63;
    }
    .search-bar-div .sp-reduce {
        margin-left: 18px;
        font-size: 20px;
        font-weight: bold;
        color: #ad6d63;
    }

.cb-div {
    display: inline-block; /* 把父元素转化为行内块状元素 */
    /*float: left; 把父元素转化为行内块状元素 */
    position: relative;
    left: 50%;
    margin-top:30px;
}

.cb-fanti-or {
    font-family: "";
    font-size: 13px;
    position: relative;
    right: 50%;
    vertical-align: middle;

}

    .cb-fanti-or .getcb {
        padding: 0;
        vertical-align: top;
    }

.search-bar-btn {
    float: left;
    width: 990px;
    padding: 32px 111px 90px 111px;

}

    .search-bar-btn .search-btn {
        width: 164px;
        height: 54px;
        background-color: #ad6d64;
        color: #ede8e2;
        border: none;
        margin-left: 314px;
    }
    .search-bar-btn .reset-btn {
        width: 164px;
        height: 54px;
        background-color: #f7b988;
        color: #bd0416;
        border: none;
        margin-left: 17px;
    }


.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.search-box{
  .info-row{
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    font-size: 14px;
    .two-btns{
      margin-left: auto;
      margin-right: auto;
      .btn1{
        margin: 10px;
        width: 160px;
        height: 40px;
        color: #c60828;
        background-color: #e5e2db ;
        border-radius: 6px;
        border-color: #D57581;

      }
      .btn2{
        margin: 10px;
        width: 160px;
        height: 40px;
        background-color: #c60828 ;
        color: #ffffff;
        border-radius: 6px;
        border: none;
      }
    }

    .btn-group{
      margin-left: 100px;
      button{
        height: 40px;
        width :40px;
        margin-left: 5px;
        margin-right: 5px;
        border: none;
        background-color:#e5e5db ;
        color: #906442;
        font-size: 35px;
      }
    }




    .hg-search1{
      margin-left: 20px;
      margin-right:20px;
      width: 150px;
      text-align: left;
      
      select{
        width:150px;
        height: 40px;

      }

    }
   
    .hg-search2{
      margin-left: 20px;
      margin-right: 100px;
      width: 600px;
      text-align: left;
      
      input{
        width:550px;
        height: 35px;

      }

    }
  }
}

.data-box{
  .data-menu{
    display: flex;
    flex-direction: row;
    justify-content: start;
    flex-wrap: wrap;
    margin: 15px 30px 15px 30px;
    .data-menu-left{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      width: 1000px;
      .l-img img{
        width: 400px;
        height: 25px;
      }

    }
    .data-menu-right{
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      width: 150px;
      .r-img img{
        width:25px;
        height: 25px;
      }
      .download-excel a{
        text-decoration: none;
        font-size: 14px;
        color: #906442;

      }
    }
  }
  .tab-data{
    .el-table .success-row {
      background: #F3F3F3;
     }
    .tab-data{
        margin-left: 20px;
    
  }
    
  }
}





</style>